import { DatePicker, GridOfWorksFields, Select } from 'components';
import { Col, Form, Row } from 'antd';
import moment from 'moment';
import { useOutletContext } from 'react-router-dom';
import { FormInstance } from 'antd/lib';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { WORKER_STATUS } from 'api';
import { useEducationsLevel } from 'hooks/useEducationsLevels';

export const Step2CompalteProfile = () => {
  const { educationsLevel, loadingEducationsLevel } = useEducationsLevel();
  const form = useOutletContext() as FormInstance;
  const userStatus = useSelector((state: any) => state.profile?.data?.state);
  const fieldsWithError = useSelector(
    (state: any) => state.profile?.data?.fieldsWithError,
  );
  const workFieldIds = useSelector(
    (state: any) => state.profile?.data?.workFieldIds,
  );
  const [selectedWorksFields, setSelectedWorksFields] = useState<string[]>([]);
  const workFieldIdsForm = Form.useWatch(['workFieldIds'], form);

  useEffect(() => {
    workFieldIdsForm?.length && setSelectedWorksFields(workFieldIdsForm);
  }, [workFieldIdsForm]);

  const onClick = useCallback(
    (id: string) => {
      if (
        selectedWorksFields.length >= 3 ||
        WORKER_STATUS.waitingRevision === userStatus
      )
        return;
      let newWorksFieldsIds = [];
      if (selectedWorksFields.includes(id)) {
        newWorksFieldsIds = selectedWorksFields.filter(
          (worksFieldId) => worksFieldId !== id,
        );
      } else {
        newWorksFieldsIds = [...selectedWorksFields, id];
      }
      setSelectedWorksFields(newWorksFieldsIds);
      form.setFieldValue('workFieldIds', newWorksFieldsIds);
    },
    [form, selectedWorksFields, userStatus],
  );

  const showError =
    workFieldIds.some((id: string) => selectedWorksFields.includes(id)) &&
    fieldsWithError?.some((field: string) => field === 'workFieldIds');

  return (
    <Form
      disabled={WORKER_STATUS.waitingRevision === userStatus}
      layout={'vertical'}
      form={form}
    >
      <Row gutter={10}>
        <Col span={12}>
          <Form.Item
            name="educationLevelId"
            rules={[
              {
                required: true,
                message: 'Nivel de Educación es requerido',
              },
            ]}
          >
            <Select
              loading={loadingEducationsLevel}
              selectType="secondary"
              options={educationsLevel}
              label="Nivel de Educación"
              placeholder="Nivel de Educación"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="worksSince"
            rules={[
              {
                required: true,
                message: 'Inicio de Actividades es requerido',
              },
            ]}
          >
            <DatePicker
              disabledDate={(date) => date > moment()}
              format={'DD/MM/YYYY'}
              datePickerType="secondary"
              label="Inicio de Actividades"
              placeholder="Inicio de Actividades"
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item hidden name="workFieldIds" rules={[{ required: true }]} />
      <Row>
        <Col span={24}>
          <p>{`Oficios a los que desea aplicar (maximo ${
            3 - selectedWorksFields.length
          })`}</p>
          {showError && <p style={{ color: 'red' }}>Valor rechazado</p>}
          <GridOfWorksFields selected={selectedWorksFields} onClick={onClick} />
        </Col>
      </Row>
    </Form>
  );
};
